import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import Box from "@mui/material/Box";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";
import IconButton from "@mui/material/IconButton";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import { Typography } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import ListItemIcon from "@mui/material/ListItemIcon";
import findIndex from "lodash/findIndex";
import { taskSliceActions } from "../../Store/Slices/TaskSlice";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";

const SelectedList = (props) => {
  // Hooks
  const dispatch = useDispatch();

  // Delete action
  const deleteFromList = (id) => {
    dispatch(taskSliceActions.removeAsset(id));
  };

  return (
    <Box sx={{ width: "100%"}}>
      <List sx={{ py: 0,}}>
        <ListItem
          disablePadding
          secondaryAction={
            <>
              {props.viewaction && (
                <IconButton
                  edge="end"
                  au6ria-label="comments"
                  sx={{ color: "primary.main"}}
                  onClick={props.view}
                >
                  <RemoveRedEyeIcon
                    sx={{
                      color: "#DB8829",
                      fontSize: "1rem",
                      "@media (min-width: 1636px)": {
                        fontSize: "1.4rem",
                      },
                    }}
                  />
                </IconButton>
              )}
              <IconButton
                edge="end"
                au6ria-label="comments"
                sx={{ color: "primary.main" }}
                onClick={() => deleteFromList(props.data.id)}
              >
                <DeleteIcon
                  sx={{
                    color: "#c40000",
                    fontSize: "1rem",
                    "@media (min-width: 1636px)": {
                      fontSize: "1.4rem",
                    },
                  }}
                />
              </IconButton>
            </>
          }
          sx={{flexDirection: 'row', flex: 1}}
        >
          <ListItemButton sx={{ borderRadius: 15, py: 0 }}>
            <ListItemText sx={{ color: "primary.main" }}>
              <Typography
                sx={{
                  fontSize: "0.8rem",
                  fontWeight: "500",
                  textOverflow: 'ellipsis',
                  "@media (min-width: 1636px)": {
                    fontSize: "1.2rem",
                  },
                  overflow: "hidden",
                  width: "90%",
                }}
              >
                {props.data ? props.data.name : ""}
              </Typography>
            </ListItemText>
          </ListItemButton>
        </ListItem>
      </List>
    </Box>
  );
};
export default SelectedList;
